import React, { useEffect, useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

const ToggleVisibilityButton: React.FC<{isVisibledPublic: boolean, changeToggle(v: boolean): void}> = ({isVisibledPublic, changeToggle}) => {

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(isVisibledPublic)
  }, [isVisibledPublic]);

  const handleToggle = () => {
    setIsVisible(prevState => !prevState);
    changeToggle(!isVisible);
  };

  return (
    <Tooltip title="Exibição para Público">
      <IconButton color='warning' onClick={handleToggle} aria-label="toggle visibility">
        {isVisible ? <VisibilityIcon /> : <VisibilityOffIcon />}
      </IconButton>
    </Tooltip>
  );
};

export default ToggleVisibilityButton;
